/* /pages/collab rate filter (sections/hg-collab-rates.liquid). Tiles stay in
   the DOM and non-matching ones drop to 0.3 opacity, so the grid never
   reflows and a creator keeps their place. "Skin" is the broad skin filter
   and also catches Acne, Pigment and Hormonal. Ported from the creator
   one-pager (dev/happyglow-partners/index.html). */
(function () {
  var SKIN = ['Acne', 'Pigment', 'Hormonal', 'Skin'];

  function init(group) {
    var root = group.closest('.hgc-rates') || document;
    var buttons = [].slice.call(group.querySelectorAll('.hgc-filter'));
    var tiles = [].slice.call(root.querySelectorAll('.hgc-rate[data-tag]'));
    if (!buttons.length || !tiles.length) return;

    function apply(f) {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.filter === f)); });
      tiles.forEach(function (t) {
        var tag = t.dataset.tag;
        var hit = f === 'All' || tag === f || (f === 'Skin' && SKIN.indexOf(tag) > -1);
        t.dataset.dim = hit ? '0' : '1';
      });
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.filter); }); });
  }

  [].slice.call(document.querySelectorAll('[data-hgc-filters]')).forEach(init);
})();
